import React, { useState, useEffect } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { Card, Row, Col, Button, Table, Form } from 'react-bootstrap';
import { useConfirmModalState } from 'global/confirmModalState';
import { getLoginInform } from 'function/login';
import { RESPONSE_CODE } from 'types/const';
import { APPROVAL_BUTTON_TEXT } from 'types/type';
import Flex from 'components/common/Flex';
import HistoryModal from 'components/pages/haccp/monitoring/common/modal/HistoryModal';

// api
import {
  excdInfoDetail,
  approvalList,
  approvalCreate
} from 'api/haccp/monitoring/commonApi';

/**
 * 모니터링 한계기준이탈 상세
 */
const Detail = () => {
  /* router info*/
  const history = useHistory();
  const { seq } = useParams();
  const { state } = useLocation();

  /* recoil */
  const { setConfirmModal } = useConfirmModalState();

  /* state */
  const [modalShow, setModalShow] = useState(false);
  const [adminYn, setAdminYn] = useState(null); // Y: 관리자, N: 이천,군산 담당자
  const [authority, setAuthority] = useState(null); // DRAFT: 기안자, FIRST: 1차결재자
  const [userSeq, setUserSeq] = useState(null); // 로그인User Seq
  const [approvalLeftBtn, setApprovalLeftBtn] = useState(null);
  const [approvalRightBtn, setApprovalRightBtn] = useState(null);
  const [approvalCmpltYn, setApprovalCmpltYn] = useState('N'); // 보고서 결재완료여부
  /**
   * 조치내역 결재 상태값
   * 결재중(3), 수정요청중(4), 결재(5)인 경우
   * 입력Form 비활성화
   */
  const [isDisabled, setIsDisabled] = useState(false);
  // 검사결과 정보
  const [resultInfo, setResultInfo] = useState({});
  // 한계기준 이탈데이터
  const [limitStandard, setLimitStandard] = useState([]);
  // 수정이력
  const [historyList, setHistoryList] = useState([]);

  /* event */

  /* 한계기준 이탈 목록페이지 이동 */
  const onList = () => {
    history.push({
      pathname: '/haccp/monitoring/criticalLimit',
      state: state
    });
  };

  /* 조치내역 목록 API호출 */
  const onHistory = async () => {
    const params = {
      inspResultExcdSeq: seq
    };
    const response = await approvalList(params);
    const { code, list } = response || {};
    if (code !== RESPONSE_CODE.Success) return;
    setHistoryList(list);
    setModalShow(true);
  };

  /* 조치내역 등록 */
  const handleSubmit = async selectBtn => {
    const { comments } = resultInfo || {};
    if (comments === '' && isDisabled === false) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: '조치내역을 입력해주세요.',
        isConfirmBtn: true
      });
      return;
    }

    let approvalText = null;

    switch (selectBtn) {
      case 'left':
        approvalText = APPROVAL_BUTTON_TEXT[approvalLeftBtn];
        break;
      case 'right':
        approvalText = APPROVAL_BUTTON_TEXT[approvalRightBtn];
        break;
    }

    setConfirmModal({
      isOpen: true,
      title: '확인',
      message: `한계기준 이탈 조치내역을 ${approvalText} 하시겠습니까?`,
      isCancelBtn: true,
      isConfirmBtn: true,
      onConfirm: () => {
        onSubmit(selectBtn);
      }
    });
  };

  const onSubmit = async selectBtn => {
    /*
     * 조치내역 결재 상태값
     * 1 : 미등록
     * 2 : 기안중
     * 3 : 결재중
     * 4 : 수정요청중
     * 5 : 결재
     *
     * 조치내역 상태값에 따른 버튼 상태값
     * 1: '임시저장'
     * 2: '결재요청'
     * 3: '수정요청'
     * 4: '수정요청 승낙'
     * 5: '수정요청 거절'
     * 6: '결재'
     * 7: '반려'
     */

    // 수정 후 결재 상태
    let updApprovalStatus = '';

    switch (selectBtn) {
      case 'left':
        if (approvalLeftBtn === 1) {
          updApprovalStatus = 2;
        } else if (approvalLeftBtn === 3) {
          updApprovalStatus = 4;
        } else if (approvalLeftBtn === 4) {
          updApprovalStatus = 2;
        } else if (approvalLeftBtn === 6) {
          updApprovalStatus = 5;
        }
        break;
      case 'right':
        if (approvalRightBtn === 2) {
          updApprovalStatus = 3;
        } else if (approvalRightBtn === 5) {
          updApprovalStatus = 3;
        } else if (approvalRightBtn === 7) {
          updApprovalStatus = 2;
        }
        break;
    }

    const { comments, approvalStatus } = resultInfo || {};

    const requestBody = {
      regUsr: userSeq, // 조치내역등록자
      prevApprovalStatus: approvalStatus, // 수정전 결재 상태
      updApprovalStatus: updApprovalStatus, // 수정후 결재 상태
      comments: comments // 조치내역
    };

    const response = await approvalCreate(seq, requestBody);
    const { code, message } = response || {};
    if (code !== RESPONSE_CODE.Success) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: message,
        isConfirmBtn: true
      });
      return;
    }

    let approvalText = null;

    switch (selectBtn) {
      case 'left':
        approvalText = APPROVAL_BUTTON_TEXT[approvalLeftBtn];
        break;
      case 'right':
        approvalText = APPROVAL_BUTTON_TEXT[approvalRightBtn];
        break;
    }

    setConfirmModal({
      isOpen: true,
      title: '확인',
      message: `조치내역이 ${approvalText} 되었습니다.`,
      isConfirmBtn: true
    });

    setModalShow(false);

    onList();
  };

  /* 상세 API호출 */
  const onDetail = async () => {
    const response = await excdInfoDetail(seq);
    const { code, data, message } = response || {};

    if (code !== RESPONSE_CODE.Success) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: message,
        isConfirmBtn: true
      });
      return;
    }

    const {
      ctgryGrpCd,
      ctgryGrpNm,
      inspResultTypeNm,
      sampleNm,
      regDttm,
      approvalStatus,
      approvalCmpltYn,
      latestComments,
      inspResultDetailMstList = [],
      coriNm,
      cshipNm
    } = data || {};

    // 검사결과 정보
    setResultInfo({
      ctgryGrpCd: ctgryGrpCd, // 분류코드
      ctgryGrpNm: ctgryGrpNm, // 분류
      inspResultTypeNm: inspResultTypeNm, // 검사결과 type
      sampleNm: sampleNm, // 품목명
      regDttm: regDttm, // 검사결과 등록일
      approvalStatus: approvalStatus, // 결재상태
      approvalCmpltYn: approvalCmpltYn, // 보고서 결재완료여부
      comments: latestComments, // 조치내역
      coriNm: coriNm, // 원산지명
      cshipNm: cshipNm // 모선명
    });

    // 한계기준 이탈데이터
    const inspResultDetailList =
      inspResultDetailMstList[0]?.inspResultDetailSubList || [];
    setLimitStandard(inspResultDetailList);

    /**
     * 조치내역 결재 상태값
     * 보고서결재(Y), 결재중(3), 수정요청중(4), 결재(5)인 경우
     * 입력Form 비활성화
     */
    if (
      approvalCmpltYn === 'Y' ||
      approvalStatus === 3 ||
      approvalStatus === 4 ||
      approvalStatus === 5
    ) {
      setIsDisabled(true);
    }

    // 보고서 종결여부
    setApprovalCmpltYn(approvalCmpltYn);
  };

  /* 로그인 정보 */
  const loginInfo = () => {
    const { adminYn, seq, haccpAuth } = getLoginInform();

    if (adminYn === 'Y') {
      setAdminYn(adminYn);
      return;
    }

    // 로그인 user Seq
    setUserSeq(seq);
    // 관리자여부
    setAdminYn(adminYn);
    // 결재권한
    setAuthority(haccpAuth);
  };

  useEffect(() => {
    if (seq === null) return;
    // 로그인 정보
    loginInfo();
    // 상세API 호출
    onDetail();
  }, [seq]);

  useEffect(() => {
    /**
     * 조치내역 결재 상태값(approvalStatus)
     * 1 : 미등록
     * 2 : 기안중
     * 3 : 결재중
     * 4 : 수정요청중
     * 5 : 결재
     *
     * 조치내역 상태값에 따른 버튼 TEXT
     * 1: '임시저장'
     * 2: '결재요청'
     * 3: '수정요청'
     * 4: '수정요청 승낙'
     * 5: '수정요청 거절'
     * 6: '결재'
     * 7: '반려'
     */

    const { approvalStatus } = resultInfo || {};

    setApprovalLeftBtn(null);
    setApprovalRightBtn(null);

    switch (authority) {
      case 'DRAFT':
        // 기안자
        if (approvalStatus === 1 || approvalStatus === 2) {
          setApprovalLeftBtn(1);
          setApprovalRightBtn(2);
        } else if (approvalStatus === 3) {
          setApprovalLeftBtn(3);
        }
        break;
      case 'FIRST':
        // 1차결재자
        if (approvalStatus === 3) {
          setApprovalLeftBtn(6);
          setApprovalRightBtn(7);
        } else if (approvalStatus === 4) {
          setApprovalLeftBtn(4);
          setApprovalRightBtn(5);
        }
        break;
    }
  }, [resultInfo.approvalStatus, authority]);
  return (
    <>
      <Card>
        <Card.Header>
          <Row className="align-items-center g-2">
            <Col>
              <h5 className="mb-0">한계기준 이탈 내역 상세</h5>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <Row className="ms-0 me-0 mt-3">
            <Col sm={12} className="ps-0 pe-0">
              <h6 className="fs-0 mb-3">검사결과 정보</h6>
              <Table bordered className="fs--1 text-center">
                <tbody>
                  원료
                  {resultInfo?.ctgryGrpCd === 'rwmtr' && (
                    <>
                      <tr>
                        <th
                          className="bg-200 text-700 border-300 border-y"
                          style={{ width: '15%' }}
                        >
                          분류
                        </th>
                        <td style={{ width: '15%' }}>
                          {resultInfo.ctgryGrpNm || '-'}
                        </td>
                        <th
                          className="bg-200 text-700 border-300 border-y"
                          style={{ width: '15%' }}
                        >
                          원산지명
                        </th>
                        <td style={{ width: '5%' }}>
                          {resultInfo.coriNm || '-'}
                        </td>
                        <th
                          className="bg-200 text-700 border-300 border-y"
                          style={{ width: '15%' }}
                        >
                          모선명
                        </th>
                        <td style={{ width: '15%' }}>
                          {resultInfo.cshipNm || '-'}
                        </td>
                      </tr>
                      <tr>
                        <th
                          className="bg-200 text-700 border-300 border-y"
                          style={{ width: '15%' }}
                        >
                          품목명
                        </th>
                        <td style={{ width: '15%' }}>
                          {resultInfo.sampleNm || '-'}
                        </td>
                        <th
                          className="bg-200 text-700 border-300 border-y"
                          style={{ width: '15%' }}
                        >
                          검사결과 등록일
                        </th>
                        <td style={{ width: '15%' }}>
                          {resultInfo.regDttm || '-'}
                        </td>
                        <th
                          className="bg-200 text-700 border-300 border-y"
                          style={{ width: '15%' }}
                        >
                          검사결과 TYPE
                        </th>
                        <td style={{ width: '15%' }}>
                          {resultInfo.inspResultTypeNm || '-'}
                        </td>
                      </tr>
                    </>
                  )}
                  {/* 제품/공정 */}
                  {resultInfo?.ctgryGrpCd !== 'rwmtr' && (
                    <>
                      <tr>
                        <th
                          className="bg-200 text-700 border-300 border-y"
                          style={{ width: '15%' }}
                        >
                          분류
                        </th>
                        <td style={{ width: '35%' }}>
                          {resultInfo.ctgryGrpNm || '-'}
                        </td>
                        <th
                          className="bg-200 text-700 border-300 border-y"
                          style={{ width: '15%' }}
                        >
                          검사결과 TYPE
                        </th>
                        <td style={{ width: '35%' }}>
                          {resultInfo.inspResultTypeNm || '-'}
                        </td>
                      </tr>
                      <tr>
                        <th
                          className="bg-200 text-700 border-300 border-y"
                          style={{ width: '15%' }}
                        >
                          품목명
                        </th>
                        <td style={{ width: '35%' }}>
                          {resultInfo.sampleNm || '-'}
                        </td>
                        <th
                          className="bg-200 text-700 border-300 border-y"
                          style={{ width: '15%' }}
                        >
                          검사결과 등록일
                        </th>
                        <td style={{ width: '35%' }}>
                          {resultInfo.regDttm || '-'}
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="ms-0 me-0 mt-3">
            <Col sm={6} className="ps-0">
              <h6 className="fs-0 mb-3">한계기준 이탈 데이터</h6>
              <div className="scrollbar" style={{ maxHeight: '226px' }}>
                <Table responsive bordered className="fs--1 text-center mb-0">
                  <thead className="bg-200 text-700 align-middle border-300">
                    <tr>
                      <th className="text-nowrap">번호</th>
                      <th className="text-nowrap">검사항목명</th>
                      <th className="text-nowrap">한계기준</th>
                      <th className="text-nowrap">측정데이터</th>
                      <th className="text-nowrap">정상여부</th>
                    </tr>
                  </thead>
                  <tbody>
                    {limitStandard?.map(
                      (
                        { inspIrdntNm, limitMthVal, inspIrdntVal, limitSts },
                        index
                      ) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{inspIrdntNm}</td>
                          <td>{limitMthVal}</td>
                          <td>{inspIrdntVal}</td>
                          <td
                            className={
                              limitSts === '기준치 이탈'
                                ? 'text-danger fw-bolder'
                                : 'text-nowrap'
                            }
                          >
                            {limitSts}
                          </td>
                        </tr>
                      )
                    )}
                    {limitStandard.length < 1 && (
                      <tr>
                        <td colSpan={5} className="w-auto">
                          한계기준 이탈정보가 존재하지 않습니다.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Col>
            <Col sm={6} className="pe-0">
              <Flex alignItems={'center'} className="mb-2">
                <h6 className="fs-0 mb-0">조치내역</h6>
                <Button
                  size="sm"
                  className="ms-auto"
                  onClick={() => onHistory()}
                >
                  수정 이력
                </Button>
              </Flex>
              <Form.Control
                as="textarea"
                rows="10"
                className="form-controll h-75"
                maxLength={1000}
                value={resultInfo.comments || ''}
                onChange={e =>
                  setResultInfo({
                    ...resultInfo,
                    comments: e.target.value
                  })
                }
                disabled={adminYn === 'Y' || isDisabled}
              />
            </Col>
          </Row>
        </Card.Body>
        <Card.Footer className="d-flex align-items-center">
          <Button
            size="sm"
            variant="secondary"
            className="ms-auto"
            onClick={() => onList()}
          >
            이전
          </Button>
          {approvalLeftBtn !== null && approvalCmpltYn === 'N' && (
            <Button
              size="sm"
              className="ms-2"
              onClick={() => handleSubmit('left')}
            >
              {APPROVAL_BUTTON_TEXT[approvalLeftBtn]}
            </Button>
          )}
          {approvalRightBtn !== null && approvalCmpltYn === 'N' && (
            <Button
              size="sm"
              className="ms-2"
              onClick={() => handleSubmit('right')}
            >
              {APPROVAL_BUTTON_TEXT[approvalRightBtn]}
            </Button>
          )}
        </Card.Footer>
      </Card>
      {/*수정이력 Modal*/}
      {modalShow === true && (
        <HistoryModal
          modalShow={modalShow}
          setModalShow={setModalShow}
          historyList={historyList}
        ></HistoryModal>
      )}
    </>
  );
};

export default Detail;
